import React from 'react';
import PropTypes from 'prop-types';
import * as Ui from './styles';
import { NotesIcon } from '../../../Icons';

const propTypes = {
  /**
 * Titulo a ser exibido no menu
 */
  title: PropTypes.string,
  /**
     * Titulo de hover do menu
     */
  hoverTitle: PropTypes.string,
  /**
   * Callback para click no menu
   */
  onMenuClick: PropTypes.func,
};

const defaultProps = {
  title: 'Anotações...',
  hoverTitle: 'Registre e recupere anotações a respeito deste resultado',
  onMenuClick: null,
};

/**
 * Componente de item de menu, que serve de gatilho
 * para a definicao de anotacoes para os resultados
 * exibidos em um card
 */
function CardAnnotationsMenu(props) {
  // props from parent
  const { onMenuClick, title, hoverTitle, className } = props;

  function onClick() {
    if (onMenuClick) {
      onMenuClick();
    }
  }

  return (
    <Ui.Container className={`CardAnnotationsMenu-wrapper ${className}`} onClick={onClick} title={hoverTitle}>
      <Ui.IconContainer>
        <NotesIcon />
      </Ui.IconContainer>
      <span>{title}</span>
    </Ui.Container>
  );
}

CardAnnotationsMenu.propTypes = propTypes;
CardAnnotationsMenu.defaultProps = defaultProps;

export default CardAnnotationsMenu;
